import React, { createElement } from 'react'
import marksy from 'marksy'
import { HeadingWithAnchor as Heading, A, Image } from 'components'

const compile = marksy({
  createElement,
  elements: {
    img: ({ src, alt }) => <Image src={src} alt={alt} />,
    h1: ({ id, children }) => <Heading is="h2" id={id}>{children}</Heading>,
    h2: ({ id, children }) => <Heading is="h3" id={id}>{children}</Heading>,
    h3: ({ id, children }) => <Heading is="h4" id={id}>{children}</Heading>,
    h4: ({ id, children }) => <Heading is="h5" id={id}>{children}</Heading>,
    h5: ({ id, children }) => <Heading is="h6" id={id}>{children}</Heading>,
    h6: ({ id, children }) => <Heading is="p" id={id}>{children}</Heading>,
    a: ({ children, ...rest }) => <A {...rest}>{children}</A>,
  },
})

export default compile



// WEBPACK FOOTER //
// /opt/build/repo/src/lib/compileMarkdown.js